import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next'; 
import { useParams } from 'react-router-dom';
import DescriptionBox from '../Components/DescriptionBox/DescriptionBox';
import ProductDisplay from '../Components/ProductDisplay/ProductDisplay';
import Footer from '../Components/Footer/Footer';

const Product = () => {
  const { productId } = useParams();
  
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const { i18n } = useTranslation(); 
  const canonicalUrl = `${window.location.origin}/${i18n.language}/product/${productId}`;
  const isFrench = i18n.language === "fr";

 // Générer les URLs hreflang dynamiquement en utilisant les langues de i18next
 const getHreflangUrls = () => {
  const allLanguages = Object.keys(i18n.options.resources);

  return allLanguages.map((lang) => ({
    hreflang: lang,
    href: `${window.location.origin}/${lang}/product/${productId}`,
  }));
};



  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await fetch(`${backendUrl}/product/${productId}`);
        const data = await response.json();

        if (data.success) {
          setProduct(data.product);
        } else {
          setError('Produit non trouvé');
        }
      } catch (err) {
        setError('Erreur lors de la récupération des informations du produit');
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [productId,backendUrl]);

  if (loading) {
    return <div>Chargement en cours...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div>
      {product ? (
        <>
          <Helmet>
            <title>{`${product.name}`} - {isFrench ? product.seo_title_fr : product.seo_title_en}</title>
            <meta name="description" content={isFrench ? product.seo_description_fr : product.seo_description_en} />
            <meta name="keywords" content={isFrench ? product.seo_keywords_fr : product.seo_keywords_en} />
            <link rel="canonical" href={canonicalUrl} />
            {getHreflangUrls().map(({ hreflang, href }) => (
              <link key={hreflang} rel="alternate" hreflang={hreflang} href={href} />
            ))}
          <script>
          {`
            !function(f,b,e,v,n,t,s) {
              if(f.fbq) return; n=f.fbq=function() { n.callMethod ?
              n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
              if(!f._fbq) f._fbq=n;
              n.push=n; n.loaded=!0; n.version='2.0';
              n.queue=[]; t=b.createElement(e); t.async=!0;
              t.src=v; s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t, s);
            }(window, document, 'script',
              'https://connect.facebook.net/en_US/fbevents.js');

            fbq('init', '1415265855733995'); 
            fbq('track', 'PageView');
            fbq('track', 'ViewContent', {
            content_name: 'Fiche produit',
            content_type: 'product',
            currency: 'EUR'     // Devise
          });
          `}
        </script>
        <noscript>
          {`
            <img height="1" width="1"
            src="https://www.facebook.com/tr?id=1415265855733995&ev=PageView&noscript=1"/>
          `}
        </noscript>
          </Helmet>
          <ProductDisplay product={product} />
          <DescriptionBox product={product} />
          <Footer />
        </>
      ) : (
        <div>Produit introuvable</div>
      )}
    </div>
  );
};

export default Product;
